"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateProposal = void 0;
const react_1 = require("@apollo/client/react");
const create_proposal_mutation_1 = require("../create-proposal.mutation");
const useCreateProposal = ({ catalog, action, description = '' }) => {
    const [createProposal, data] = (0, react_1.useMutation)(create_proposal_mutation_1.CREATE_PROPOSAL, { variables: { catalog, action, description } });
    return Object.assign({ createProposal }, data);
};
exports.useCreateProposal = useCreateProposal;
exports.default = exports.useCreateProposal;
